interface Stat {
  value: string;
  label: string;
}

interface ContactHeaderProps {
  stats?: Stat[];
}

const DEFAULT_STATS: Stat[] = [
  { value: "142", label: "issues" },
  { value: "18", label: "PRs" },
  { value: "avg response", label: "" },
  { value: "2 days", label: "" },
];

export default function ContactHeader({
  stats = DEFAULT_STATS,
}: ContactHeaderProps) {
  const topStats = stats.slice(0, 2);
  const bottomStats = stats.slice(2, 4);

  return (
    <div className="max-w-6xl mx-auto px-6 pt-10 pb-8 flex flex-col gap-4 sm:flex-row sm:items-end sm:justify-between sm:gap-6 animate-fade-up">
      <div>
        <h1 className="font-playfair text-stone-800 text-[45px] sm:text-[60px] mb-3 leading-tight">
          open a{" "}
          <span
            className="font-script italic text-burgundy"
            style={{ fontSize: "1.9em" }}
          >
            pull request
          </span>
        </h1>
        <p className="font-montserrat text-stone-600 text-[18px] mb-1">
          Pitch a guest, partner with us, slide into the inbox. We read every
          one.
        </p>
        <p
          className="font-montserrat text-stone-500"
          style={{ fontSize: "15px" }}
        >
          Replies usually within a week.
        </p>
      </div>

      <div className="text-left sm:text-right flex-shrink-0">
        <p
          className="font-montserrat text-stone-500"
          style={{ fontSize: "15px", letterSpacing: "0.06em" }}
        >
          {topStats.map((s, i) => (
            <span key={i}>
              {i > 0 && " · "}
              <span className="text-stone-700 font-medium">{s.value}</span>
              {s.label && ` ${s.label}`}
            </span>
          ))}
        </p>
        <p
          className="font-montserrat text-stone-500 mt-0.5"
          style={{ fontSize: "15px", letterSpacing: "0.06em" }}
        >
          {bottomStats.map((s, i) => (
            <span key={i}>
              {i > 0 && " · "}
              <span className="text-stone-700 font-medium">{s.value}</span>
              {s.label && ` ${s.label}`}
            </span>
          ))}
        </p>
      </div>
    </div>
  );
}
